<div (click)="contactMelissa()" class="contact-area">
    <div>
        <div class="site-logo">
            <img width="45" src="/assets/logo.jpg">
        </div>
        <div class="contact-text">
            <div>
                <div>Crafty By Melissa</div>
                <div class="contact-subtitle">
                contact melissa
                </div>
            </div>
        </div>
    </div>
</div>
<div [ngClass]="{'contact-clicked': contactClicked}" class="bg-light text-secondary contact-details">
    <div>melissa@craftybymelissa.xyz</div>
    <div>678-689-9552</div>
</div>